import confetti from "canvas-confetti";

//https://github.com/catdad/canvas-confetti?tab=readme-ov-file#options
const StarShooting = () => {
    var defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: ['ffdc00', '52288e', 'ffdc00', '52288e', 'ffdc00']
      };
      
      function shoot() {
        confetti({
          ...defaults,
          particleCount: 40,
          scalar: 1.2,
          shapes: ['star']
        });
        // confetti({
        //   ...defaults,
        //   particleCount: 10,
        //   scalar: 0.75,
        //   shapes: ['circle']
        // });
      }
      
      setTimeout(shoot, 0);
      setTimeout(shoot, 200);
      setTimeout(shoot, 400);
      setTimeout(shoot, 600);
      setTimeout(shoot, 800);
};

export default StarShooting;
